// extracted by mini-css-extract-plugin
module.exports = {"ourTitle":"News_ourTitle__uyKVr","newsTitle":"News_newsTitle__18lRJ","news":"News_news__3R8YY","container":"News_container__1ieYf","counters":"News_counters__2_0Q2"};